import {
  ATENDABOT_PRODUCT_IMAGE,
  PRODUCT_IMAGES,
} from '../branding/assets';

const sourceMatchers = [
  { key: 'atendabot', terms: ['atendabot', 'atenda_bot', 'atenda-bot', 'atenda bot'] },
  { key: 'feedback_hero', terms: ['feedback_hero', 'feedback-hero', 'feedbackhero', 'feedback'] },
  { key: 'reservo', terms: ['reservo'] },
  { key: 'cardapio', terms: ['cardapio', 'one_menu', 'one-menu', 'onemenu', 'one menu'] },
  { key: 'cv', terms: ['cv', 'curriculo', 'curriculo_certo', 'curriculo-certo'] },
];

const normalizeToken = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

export const FOODSTATION_TRIAL_PRODUCTS = [
  {
    key: 'atendabot',
    name: 'AtendaBot',
    image: ATENDABOT_PRODUCT_IMAGE,
    backgroundColor: '#3127A0',
    logoSize: '78%',
    anchor: 'atendabot',
  },
  {
    key: 'feedback_hero',
    name: 'Feedback Hero',
    image: PRODUCT_IMAGES.feedbackHero,
    backgroundColor: '#143023',
    logoSize: '78%',
    anchor: 'feedback',
  },
  {
    key: 'reservo',
    name: 'Reservo',
    image: PRODUCT_IMAGES.reservo,
    backgroundColor: '#ffdb2f',
    logoSize: '78%',
    anchor: 'reservo',
  },
  {
    key: 'cardapio',
    name: 'One Menu',
    image: PRODUCT_IMAGES.oneMenu,
    backgroundColor: '#fff6f3',
    logoSize: '80%',
    anchor: 'onemenu',
  },
  {
    key: 'cv',
    name: 'Curriculo Certo',
    image: PRODUCT_IMAGES.cv,
    backgroundColor: '#000000',
    logoSize: '72%',
    anchor: 'cv',
  },
];

export const normalizeProductSource = (value) => {
  if (!value) return null;

  const raw = String(value).trim().toLowerCase();
  const normalized = normalizeToken(raw);

  for (const matcher of sourceMatchers) {
    if (
      matcher.terms.some((term) => {
        const normalizedTerm = normalizeToken(term);
        return normalized === normalizedTerm
          || normalized.includes(normalizedTerm)
          || raw.includes(term.toLowerCase());
      })
    ) {
      return matcher.key;
    }
  }

  return null;
};

export const getProductSourceFromSearch = (search) => {
  const params = new URLSearchParams(search || '');
  const sourceParams = ['produto', 'product', 'source', 'origem', 'from'];

  for (const param of sourceParams) {
    const source = normalizeProductSource(params.get(param));
    if (source) return source;
  }

  return null;
};

export const getProductSourceFromReferrer = (referrer) => {
  if (!referrer) return null;

  try {
    const url = new URL(referrer);
    return normalizeProductSource(`${url.pathname} ${url.search}`);
  } catch (error) {
    return normalizeProductSource(referrer);
  }
};

export const orderProductsBySource = (
  products = FOODSTATION_TRIAL_PRODUCTS,
  source
) => {
  const sourceKey = normalizeProductSource(source);
  if (!sourceKey) return [...products];

  return [...products].sort((a, b) => {
    if (a.key === sourceKey) return -1;
    if (b.key === sourceKey) return 1;
    return 0;
  });
};
